import {Rule} from '@rc-component/form/lib/interface';

export const emailRules: Rule[] = [
	{required: true, message: 'Введите email'},
	{type: 'email', message: 'Некорректный email'},
];

export const passwordRules: Rule[] = [{required: true, message: 'Введите пароль'}];
